import React from 'react'
import { TimescaleSelectorBase, baseStyles } from '../_base'

export default function TimescaleSelectorWrapper(props) {
  return <TimescaleSelectorBase styles={baseStyles} {...props} />
}
